module.exports = __webpack_public_path__ + "static/img/customer7-2.758a7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneCasePage/customer7-2.png
// module id = /8U1
// module chunks = 0